import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import excelIcon from '../../../assets/img/icons/excel-green.svg';
import ButtonTextLoader from '../../../components/Loaders/ButtonTextLoader';
import BottomPagination from '../../../components/Pagination/BottomPagination/BottomPagination';
import TopPagination from '../../../components/Pagination/TopPagination/TopPagination';
import {
  ButtonIcon,
  WhiteButtonWithIcon,
} from '../../../styledComponents/buttons';
import {
  CommonGrid,
  HeaderContainer,
  PageTitle,
} from '../../../styledComponents/common';
import EmtithalOfficeTasksFilter from './EmtithalOfficeTasksFilter';
import EmtithalOfficeTasksList from './EmtithalOfficeTasksList';

const PAGE_SIZE = 30;

const EmtithalOfficeTasks = ({
  getEmtithalOfficeTasks,
  taskList,
  isLoading,
  getPublicZoneList,
  publicZoneList,
  officesShortList,
  getOfficesShortList,
  getTaskLocation,
  locationsList,
  totalCount,
  pageSize,
  exportEmtithalOfficeTasksReport,
  exportLoading,
}) => {
  const { t } = useTranslation();
  const [filters, setFilters] = useState({
    publicZone: null,
    office: null,
    location: null,
    searchTerm: '',
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [expandedTaskId, setExpandedTaskId] = useState(null);

  useEffect(() => {
    getPublicZoneList();
  }, [getPublicZoneList]);

  useEffect(() => {
    const payload = {
      page: currentPage,
      page_size: PAGE_SIZE,
    };
    if (filters?.publicZone?.value) {
      payload.public_zone_id = filters.publicZone.value;
    }
    if (filters?.office?.value) {
      payload.office_id = filters.office.value;
    }
    if (filters?.location?.value) {
      payload.location_id = filters.location.value;
    }
    if (filters?.searchTerm?.trim()) {
      payload.name = filters.searchTerm.trim();
    }
    getEmtithalOfficeTasks(payload);
  }, [getEmtithalOfficeTasks, filters, currentPage]);

  const handlePageChange = page => {
    setCurrentPage(page);
  };

  const isExportDisabled = () => {
    return !filters?.publicZone?.value || !filters?.office?.value;
  };

  const handleExportEmtithalOfficeTasksReport = () => {
    if (isExportDisabled()) return;
    const payload = {};
    if (filters?.publicZone?.value) {
      payload.public_zone_id = filters.publicZone.value;
    }
    if (filters?.office?.value) {
      payload.office_id = filters.office.value;
    }
    if (filters?.location?.value) {
      payload.location_id = filters.location.value;
    }
    if (filters?.searchTerm?.trim()) {
      payload.name = filters.searchTerm.trim();
    }
    exportEmtithalOfficeTasksReport(payload);
  };

  return (
    <div className="content">
      <CommonGrid alignItem="center">
        <PageTitle>{t('emtithal_tasks')}</PageTitle>
        <WhiteButtonWithIcon
          onClick={handleExportEmtithalOfficeTasksReport}
          color="#19AC65"
          borderColor="#19AC65"
          hoverBorderColor="#129652"
          padding={exportLoading ? '0 45px' : '0 25px'}
          disabled={exportLoading || isExportDisabled()}
        >
          {exportLoading ? (
            <ButtonTextLoader color="#19AC65" loadingText=" " size={6} />
          ) : (
            <>
              <ButtonIcon src={excelIcon} size="26px" />
              {t('export_report')}
            </>
          )}
        </WhiteButtonWithIcon>
      </CommonGrid>
      <HeaderContainer>
        <EmtithalOfficeTasksFilter
          publicZoneList={publicZoneList}
          getOfficesShortList={getOfficesShortList}
          officesShortList={officesShortList}
          getTaskLocation={getTaskLocation}
          locationList={locationsList}
          onFilterChange={setFilters}
        />
      </HeaderContainer>
      {totalCount > 0 && pageSize && (
        <TopPagination
          itemName={t('tasks')}
          totalCount={totalCount}
          currentPage={currentPage}
          onPageChange={handlePageChange}
          pageSize={pageSize}
        />
      )}
      <EmtithalOfficeTasksList
        taskList={taskList}
        isLoading={isLoading}
        expandedTaskId={expandedTaskId}
        setExpandedTaskId={setExpandedTaskId}
      />
      {totalCount > 0 && pageSize && (
        <BottomPagination
          totalCount={totalCount}
          currentPage={currentPage}
          onPageChange={handlePageChange}
          pageSize={pageSize}
        />
      )}
    </div>
  );
};

export default EmtithalOfficeTasks;
